var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-item"},[_c('div',{staticClass:"faq-item-q"},[_c('span',{staticStyle:{"color":"red"}},[_vm._v("Q：")]),_vm._v(_vm._s(_vm.faq.title))]),_c('div',{staticClass:"faq-item-a"},[_c('div',[_vm._v("A：")]),_c('div',[_vm._l((_vm.mesList),function(mes,index){return [_c('div',{key:index},[_vm._v(_vm._s(mes))])]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }